import { render, staticRenderFns } from "./ModalImpressao.vue?vue&type=template&id=5dfd595e&"
import script from "./ModalImpressao.vue?vue&type=script&lang=js&"
export * from "./ModalImpressao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports